// Version History dialog — a scrollable, user-friendly changelog rendered from
// lib/version.js (CHANGELOG, newest first). Opened from the version label under
// the app title or the "Version history" item in the ☰ Open menu.
import { For, Show } from 'solid-js';
import Modal from './Modal.jsx';
import { CHANGELOG, VERSION } from '../lib/version.js';

export default function VersionHistory(props) {
  return (
    <Modal open={props.open} onClose={props.onClose} title={`Version history — v${VERSION}`} cardClass="vh-card">
      <div class="vh-scroll">
        <For each={CHANGELOG}>
          {(e) => (
            <div class="vh-entry">
              <div class="vh-head">
                <span class="vh-ver">v{e.version}</span>
                <span class="vh-title">{e.title}</span>
                <span class="vh-date">{e.date}</span>
              </div>
              <Show when={e.intro && e.intro.length}>
                <div class="vh-intro">
                  <For each={Array.isArray(e.intro) ? e.intro : [e.intro]}>{(p) => <p>{p}</p>}</For>
                </div>
              </Show>
              <Show when={e.philosophy && e.philosophy.length}>
                <div class="vh-phil">
                  <div class="vh-subhead">What Ninocat is obsessed with</div>
                  <For each={e.philosophy}>
                    {(p) => (
                      <div class="vh-phil-item">
                        <span class="vh-phil-title">{p.title}</span>
                        <span class="vh-phil-text">{p.text}</span>
                      </div>
                    )}
                  </For>
                </div>
              </Show>
              <Show when={e.notes && e.notes.length}>
                <div class="vh-subhead">What’s included</div>
                <ul class="vh-notes">
                  <For each={e.notes}>{(n) => <li>{n}</li>}</For>
                </ul>
              </Show>
            </div>
          )}
        </For>
      </div>
    </Modal>
  );
}
